import React from 'react';
import { BottomNavItemStyled, LabelStyled } from './bottomNavItem.styled';
import Icon from '../Icon';

interface BottomNavProps {
  value?: string;
  active?: boolean;
  label?: string;
  iconName?: string; // TODO think about passing icon as a component?
  onClick?: (event: React.MouseEvent<HTMLElement>, value: string) => void;
}

const BottomNavItem = ({
  onClick = () => {},
  active,
  value,
  label,
  iconName,
}: BottomNavProps) => {
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    onClick(event, value);
  };

  return (
    <BottomNavItemStyled active={active} onClick={handleClick}>
      {iconName ? <Icon name={iconName} /> : null}
      {label ? <LabelStyled>{label}</LabelStyled> : null}
    </BottomNavItemStyled>
  );
};

export default BottomNavItem;
